import "./src/styles/index.scss"
import "./src/styles/prism-dracula.scss"

require("prismjs/plugins/line-numbers/prism-line-numbers.css")
